import React from 'react';
import { FilterSelect } from '../../shared/table/FilterSelect';
import { AttachmentContextTrigger } from '../shared';

export const TaskDetailSidebar = ({
    openSidebarPanels,
    handleToggleSidebarPanel,
    form,
    getTicketStatusLabel,
    ticketTypeBadgeMap,
    ticketTypeIconMap,
    getTicketTypeLabel,
    getTicketPriorityLabel,
    dueFromNow,
    formatDateTime,
    ticket,
    users,
    groups,
    handleFormSelectChange,
    getFollowAuthorAvatar,
    attachments,
    openAttachmentMenuId,
    handleToggleAttachmentMenu,
    handleDownloadAttachment,
    tagBadges,
    handleRemoveTag,
    tagInput,
    setTagInput,
    handleAddTag,
}) => {
    return (
        <div className="col-12 col-xxl-3 order-2 order-xxl-2 mt-3 mt-xxl-0">
            <div className="ticket-detail-sidebar-scroll" style={{ paddingBottom: '40px' }}>
                <div className="ticket-sidebar-accordion">
                    <div className="ticket-sidebar-accordion__item">
                        <button
                            type="button"
                            className="ticket-sidebar-accordion__trigger"
                            onClick={() => handleToggleSidebarPanel('properties')}
                            aria-expanded={openSidebarPanels.properties}
                        >
                            <span>Propiedades del ticket</span>
                            <i className={`bi ${openSidebarPanels.properties ? 'bi-chevron-up' : 'bi-chevron-down'}`} aria-hidden="true" />
                        </button>

                        {openSidebarPanels.properties && (
                            <div className="ticket-sidebar-accordion__body">
                                <div className="ticket-summary-list mt-1">
                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Estado</div>
                                        <div className="ticket-summary-item__value d-flex align-items-center gap-2">
                                            <span className={`ticket-status-dot ticket-status-dot--${form.status === 'NEW' ? 'success' : (form.status === 'OPEN' ? 'primary' : (form.status === 'IN_PROGRESS' ? 'warning' : (form.status === 'CANCELLED' ? 'danger' : 'info')))}`} />
                                            <span>{getTicketStatusLabel(form.status)}</span>
                                        </div>
                                    </div>

                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Tipo</div>
                                        <div className="ticket-summary-item__value">
                                            <span className={`badge d-inline-flex align-items-center gap-1 ${ticketTypeBadgeMap[String(form.type || '').toUpperCase()] || 'bg-soft-secondary text-secondary'}`}>
                                                <i className={ticketTypeIconMap[String(form.type || '').toUpperCase()] || 'bi bi-tag'} />
                                                <span>{getTicketTypeLabel(form.type)}</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Prioridad</div>
                                        <div className="ticket-summary-item__value">{getTicketPriorityLabel(form.priority)}</div>
                                    </div>

                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Vencimiento</div>
                                        <div className="ticket-summary-item__value">{dueFromNow}</div>
                                        <div className="ticket-summary-item__meta">{formatDateTime(ticket.resolutionDueDate)}</div>
                                    </div>

                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Cliente</div>
                                        <div className="ticket-summary-item__value">{ticket.customer?.name || '-'}</div>
                                    </div>

                                    <div className="ticket-summary-item">
                                        <div className="ticket-summary-item__label">Proyecto</div>
                                        <div className="ticket-summary-item__value">{ticket.project?.name || '-'}</div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>

                    <div className="ticket-sidebar-accordion__item">
                        <button
                            type="button"
                            className="ticket-sidebar-accordion__trigger"
                            onClick={() => handleToggleSidebarPanel('requesterInfo')}
                            aria-expanded={openSidebarPanels.requesterInfo}
                        >
                            <span>Información del solicitante</span>
                            <i className={`bi ${openSidebarPanels.requesterInfo ? 'bi-chevron-up' : 'bi-chevron-down'}`} aria-hidden="true" />
                        </button>

                        {openSidebarPanels.requesterInfo && (
                            <div className="ticket-sidebar-accordion__body">
                                <div className="row g-2">
                                    <div className="col-12">
                                        <label className="form-label">Solicitante</label>
                                        <FilterSelect
                                            value={form.requester}
                                            searchable
                                            searchPlaceholder="Buscar solicitante..."
                                            options={[
                                                { value: '', label: 'Sin solicitante' },
                                                ...users.map((user) => ({
                                                    value: user._id,
                                                    label: user.name || user.email,
                                                    meta: user.email || '',
                                                    avatar: getFollowAuthorAvatar(user),
                                                })),
                                            ]}
                                            onChange={(nextValue) => handleFormSelectChange('requester', nextValue)}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Asignado a</label>
                                        <FilterSelect
                                            value={form.assignee}
                                            searchable
                                            searchPlaceholder="Buscar asignado..."
                                            options={[
                                                { value: '', label: 'Sin asignar' },
                                                ...users.map((user) => ({
                                                    value: user._id,
                                                    label: user.name || user.email,
                                                    meta: user.email || '',
                                                    avatar: getFollowAuthorAvatar(user),
                                                })),
                                            ]}
                                            onChange={(nextValue) => handleFormSelectChange('assignee', nextValue)}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Grupo</label>
                                        <FilterSelect
                                            value={form.group}
                                            searchable
                                            searchPlaceholder="Buscar grupo..."
                                            options={[
                                                { value: '', label: 'Sin grupo', icon: 'bi bi-people' },
                                                ...groups.map((group) => ({
                                                    value: group.name,
                                                    label: `${group.code} - ${group.name}`,
                                                    meta: group.description || '',
                                                    icon: 'bi bi-people',
                                                })),
                                            ]}
                                            onChange={(nextValue) => handleFormSelectChange('group', nextValue)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="ticket-sidebar-accordion__item">
                        <button
                            type="button"
                            className="ticket-sidebar-accordion__trigger"
                            onClick={() => handleToggleSidebarPanel('attachmentsTags')}
                            aria-expanded={openSidebarPanels.attachmentsTags}
                        >
                            <span>Adjuntos y etiquetas</span>
                            <i className={`bi ${openSidebarPanels.attachmentsTags ? 'bi-chevron-up' : 'bi-chevron-down'}`} aria-hidden="true" />
                        </button>

                        {openSidebarPanels.attachmentsTags && (
                            <div className="ticket-sidebar-accordion__body">
                                <div className="mb-3">
                                    <label className="form-label">Adjuntos</label>

                                    {attachments.length === 0 && <div className="text-muted">No hay adjuntos.</div>}
                                    {attachments.length > 0 && (
                                        <div className="d-flex flex-column gap-2">
                                            {attachments.map((file) => (
                                                <AttachmentContextTrigger
                                                    key={file._id}
                                                    file={file}
                                                    isOpen={openAttachmentMenuId === file._id}
                                                    onToggle={handleToggleAttachmentMenu}
                                                    onDownload={handleDownloadAttachment}
                                                    buttonClassName="btn btn-light-brand text-start w-100"
                                                    wrapperClassName="position-relative w-100"
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="">
                                    <label className="form-label">Etiquetas</label>
                                    {tagBadges.length > 0 && (
                                        <div className="d-flex flex-wrap gap-1 mt-2 mb-2">
                                            {tagBadges.map((tag) => (
                                                <span key={`detail-tag-${tag}`} className="badge bg-soft-primary text-primary d-inline-flex align-items-center gap-1">
                                                    <span>{tag}</span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-primary lh-1"
                                                        onClick={() => handleRemoveTag(tag)}
                                                        aria-label={`Quitar etiqueta ${tag}`}
                                                    >
                                                        ×
                                                    </button>
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    <div className="input-group input-group-sm">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={tagInput}
                                            onChange={(event) => setTagInput(event.target.value || '')}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ',') {
                                                    event.preventDefault();
                                                    handleAddTag();
                                                }
                                            }}
                                            placeholder="Escribe una etiqueta y presiona Enter"
                                        />
                                        <button type="button" className="btn btn-outline-secondary" onClick={handleAddTag} aria-label="Agregar etiqueta">
                                            <i className="bi bi-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};